if (!customElements.get('shipping-countdown')) {
  customElements.define(
    'shipping-countdown',
    class ShippingCountdown extends HTMLElement {
      connectedCallback() {
        this.messageTarget = this.querySelector('[data-shipping-message]');
        this.countdownTarget = this.querySelector('[data-countdown]');
        this.afterCutoffOffsetDays = Number.parseInt(this.dataset.afterCutoffOffsetDays || '1', 10);
        this.cutoffTimes = [
          this.dataset.cutoffSunday || '',
          this.dataset.cutoffMonday || '',
          this.dataset.cutoffTuesday || '',
          this.dataset.cutoffWednesday || '',
          this.dataset.cutoffThursday || '',
          this.dataset.cutoffFriday || '',
          this.dataset.cutoffSaturday || '',
        ];

        if (!this.messageTarget || !this.countdownTarget) return;

        if (Number.isNaN(this.afterCutoffOffsetDays) || this.afterCutoffOffsetDays < 0) {
          this.afterCutoffOffsetDays = 1;
        }

        this.updateDisplay();
        this.intervalId = window.setInterval(() => this.updateDisplay(), 1000);
      }

      disconnectedCallback() {
        if (this.intervalId) {
          window.clearInterval(this.intervalId);
        }
      }

      getJstNowParts() {
        const jstNow = new Date(Date.now() + 9 * 60 * 60 * 1000);
        return {
          year: jstNow.getUTCFullYear(),
          month: jstNow.getUTCMonth() + 1,
          day: jstNow.getUTCDate(),
          weekday: jstNow.getUTCDay(),
        };
      }

      getJstTimestamp(year, month, day, hour = 0, minute = 0) {
        return Date.UTC(year, month - 1, day, hour - 9, minute, 0, 0);
      }

      addJstDays(parts, daysToAdd) {
        const shiftedDate = new Date(Date.UTC(parts.year, parts.month - 1, parts.day + daysToAdd));
        return {
          year: shiftedDate.getUTCFullYear(),
          month: shiftedDate.getUTCMonth() + 1,
          day: shiftedDate.getUTCDate(),
          weekday: shiftedDate.getUTCDay(),
        };
      }

      getTodayCutoff() {
        const nowParts = this.getJstNowParts();
        const cutoffTime = this.cutoffTimes[nowParts.weekday] || '';
        const timeMatch = cutoffTime.match(/^(\d{1,2}):(\d{2})$/);

        if (!timeMatch) {
          return null;
        }

        const cutoffHour = Number.parseInt(timeMatch[1], 10);
        const cutoffMinute = Number.parseInt(timeMatch[2], 10);

        if (
          Number.isNaN(cutoffHour) ||
          Number.isNaN(cutoffMinute) ||
          cutoffHour < 0 ||
          cutoffHour > 23 ||
          cutoffMinute < 0 ||
          cutoffMinute > 59
        ) {
          return null;
        }

        return {
          nowParts,
          cutoffTimestamp: this.getJstTimestamp(
            nowParts.year,
            nowParts.month,
            nowParts.day,
            cutoffHour,
            cutoffMinute
          ),
        };
      }

      showShippingDate(nowParts) {
        const shippingDate = this.addJstDays(nowParts, this.afterCutoffOffsetDays);
        this.messageTarget.textContent = `${shippingDate.month}月${shippingDate.day}日発送`;
      }

      updateDisplay() {
        const nowTimestamp = Date.now();
        const todayCutoff = this.getTodayCutoff();

        if (!todayCutoff) {
          this.showShippingDate(this.getJstNowParts());
          return;
        }

        if (nowTimestamp >= todayCutoff.cutoffTimestamp) {
          this.showShippingDate(todayCutoff.nowParts);
          return;
        }

        const remainingMs = Math.max(todayCutoff.cutoffTimestamp - nowTimestamp, 0);
        const remainingMinutes = Math.max(1, Math.ceil(remainingMs / 60000));
        const hours = Math.floor(remainingMinutes / 60);
        const minutes = remainingMinutes % 60;
        const countdownText = hours > 0 ? `${hours}時間${minutes}分` : `${minutes}分`;

        this.countdownTarget.textContent = countdownText;
        this.messageTarget.innerHTML = `<span data-countdown>${countdownText}</span>以内の注文で当日発送`;
        this.countdownTarget = this.querySelector('[data-countdown]');
      }
    }
  );
}
